import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Textarea, TextInput, createStyles } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import tinycolor from "tinycolor2";

const useStyles = createStyles((theme, { colors }) => ({
  formStyle: {
    "&:focus": {
      border: `1px solid ${tinycolor(colors.background_color).darken(20).toString()}`
    }
  }
}));

export default function SurveyTextInput({ value, format, onChange }) {
  const colors = useSelector((state) => state.colors);

  const { classes } = useStyles({ colors });
  const { t } = useTranslation();

  const [text, setText] = useState(typeof value === "string" ? value : "");
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (typeof value === "string" && !updated) {
      setText(value);
      setUpdated(true);
    }
  }, [value, updated]);

  const onChangeText = (newValue) => {
    setText(newValue);
    if (typeof onChange === "function") {
      onChange(newValue);
    }
  };

  if (format === "date") {
    return (
      <DatePicker
        value={text ? DateTime.fromISO(text).toJSDate() : null}
        defaultValue={text ? DateTime.fromISO(text).toJSDate() : new Date()}
        placeholder="Select a date"
        onChange={(date) => {
          const iso = date ? DateTime.fromJSDate(date).toISODate() : "";
          onChangeText(iso);
        }}
        mt={10}
        size="sm"
        zIndex={99999}
      />
    );
  }

  const Input = format === "text" ? Textarea : TextInput;

  return (
    <Input
      value={text}
      mt={10}
      placeholder={t("survey.question.yourAnswer")}
      size="sm"
      type={format === "number" ? "number" : "text"}
      styles={{ input: classes.formStyle }}
      onChange={(e) => onChangeText(e.currentTarget.value)}
    />
  );
}